// extracted by mini-css-extract-plugin
export default {"popupWrapper":"SingleVideoPlayer_popupWrapper__aLC6T","parentDiv":"SingleVideoPlayer_parentDiv__ZDMGq","contentDiv":"SingleVideoPlayer_contentDiv__Oz9iG"};